





































import { Component, Vue } from 'vue-property-decorator';
import AlzuhudHeader from '@/components/AlzuhudHeader.vue'; // @ is an alias to /src
import FeatureSection from '@/components/FeatureSection.vue';
import TestimonialSection from '@/components/TestimonialSection.vue';
import HeaderSection from '@/components/HeaderSection.vue';
import PackagesSection from '@/components/PackagesSection.vue';
import AppSection from '@/components/AppSection.vue';
import Footer from '@/components/Footer.vue';
import btn from '@/components/btn.vue';
import { State } from 'vuex-class';

@Component({
  components: {
    AlzuhudHeader,
    FeatureSection,
    TestimonialSection,
    HeaderSection,
    PackagesSection,
    AppSection,
    Footer,
    btn
  },
})
export default class Home extends Vue {
  @State language: any;
  mounted() {
    document.title = 'Home - Alzuhud';
  }
}
